import gql from 'graphql-tag';

const WearableProvidersQuery = gql`
  query WearableProvidersCatalog {
    wearableProviders {
      openWearablesProvider
      displayName
      iconUrl
      availability
      displayOrder
    }
  }
`;

export default WearableProvidersQuery;
